import { ComponentProps } from "react";
import { Interpolation, Theme, css } from "@emotion/react";
import { Text } from "components/core/Text";

export const ArchiveTags = ({
  tags,
  tagEnums,
  color,
  ...props
}: {
  tags: string[] | null;
  tagEnums: Array<{ value: string; comment?: string | null }>;
  color?: ComponentProps<typeof Text>["color"];
  css?: Interpolation<Theme>;
}) => {
  if (!tags || tags.length === 0) {
    return null;
  }

  // Create a map of tag values to their comments for quick lookup
  const tagMap = new Map(
    tagEnums
      .filter((tag) => tag.comment)
      .map((tag) => [tag.value, tag.comment!])
  );

  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        overflow: hidden;
      `}
      {...props}
    >
      {tags.map((tagValue) => {
        const tagComment = tagMap.get(tagValue);
        if (!tagComment) return null;

        return (
          <Text
            key={tagValue}
            variant="body4"
            color={color || "primary.dark"}
            css={css`
              &:not(:last-child)::after {
                content: "·";
                margin: 0 4px;
              }
            `}
          >
            {tagComment}
          </Text>
        );
      })}
    </div>
  );
};
